import { Clock } from 'lucide-react';
import type { TimeRange } from '@/lib/types';

export type { TimeRange };

interface TimeRangeSelectorProps {
  value: TimeRange;
  onChange: (range: TimeRange) => void;
}

const TIME_RANGES: { value: TimeRange; label: string }[] = [
  { value: '15m', label: 'Last 15 minutes' },
  { value: '1h', label: 'Last hour' },
  { value: '24h', label: 'Last 24 hours' },
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: 'all', label: 'All time' },
];

export default function TimeRangeSelector({ value, onChange }: TimeRangeSelectorProps) {
  return (
    <div className="flex items-center gap-2">
      <Clock className="h-4 w-4 text-muted-foreground" />
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as TimeRange)}
        aria-label="Time range"
        className="px-3 py-2 rounded-md bg-background border border-border text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 hover:bg-muted/30 transition-colors cursor-pointer"
        style={{ colorScheme: 'dark' }}
      >
        {TIME_RANGES.map((range) => (
          <option key={range.value} value={range.value} className="bg-background text-foreground">
            {range.label}
          </option>
        ))}
      </select>
    </div>
  );
}
